import { parse } from 'date-fns';
import i18n from 'i18next';

import { API_DATE_FORMAT, format } from '../../../../utils';
import { SelectedFare } from '../../../../DesktopFlight/types';

export function getSelectedFlightsInfo(flights: SelectedFare[] = []): string {
	if (!flights.length) {
		return '';
	}

	return flights
		.map(flight => {
			if (!flight?.flightInfo?.segments?.length) {
				return '';
			}

			return flight.flightInfo.segments
				.map(segment => {
					const flightDate = format(
						parse(segment.segment.departure.date, API_DATE_FORMAT, new Date()),
						'dd.MM.yyyy'
					);

					return i18n.t(
						'Exchange:{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф {{tariff}}',
						{
							segmentId: parseInt(segment.segment.id, 10) + 1,
							depDate: flightDate,
							airlineCode: segment.segment.marketingAirline.iata,
							flightNumber: segment.segment.flightNumber,
							depIata: segment.segment.departure?.airport?.iata,
							depTime: segment.segment.departure.time,
							arrIata: segment.segment.arrival.airport.iata,
							arrTime: segment.segment.arrival.time,
							tariff: flight.fareName
						}
					);
				})
				.join('\n');
		})
		.filter(Boolean)
		.join('\n');
}
